module.exports = __webpack_public_path__ + "static/img/1.2486b7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/1.png
// module id = eDI0
// module chunks = 0